import { render, staticRenderFns } from "./MyTechPreviewItem.vue?vue&type=template&id=199c3a14"
import script from "./MyTechPreviewItem.vue?vue&type=script&lang=js"
export * from "./MyTechPreviewItem.vue?vue&type=script&lang=js"
import style0 from "./MyTechPreviewItem.vue?vue&type=style&index=0&id=199c3a14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports